// IMPORTS:

// STYLES
import 'bootstrap/scss/bootstrap.scss'
import 'choices.js/public/assets/styles/choices.min.css'

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss'

// Popper - neccessary for bootstrap
import '@popperjs/core'

// Bootstrap
import 'bootstrap'

// PLUGINS
import './plugins/PluginLoadDependecies.ts'
import './plugins/PluginOutline.ts'
import './plugins/PluginDeviceType.ts'
import './plugins/PluginRecaptcha.ts'
import './plugins/PluginSVGConverter.ts'
import './plugins/PluginBwMenu.ts'
import LazyLoad, { LazyMode } from './plugins/PluginLazyLoad.ts'
import LASingleLettersBreaker from './plugins/PluginSingleLetters.ts'
import { CookiesController } from './plugins/PluginCookies.ts'

import './components/ComponentAos.ts'
import './components/ComponentSelect.ts'

// Create CookiesController instance
window.CookiesController = new CookiesController()

new LASingleLettersBreaker({ autoInit: true })

window.addEventListener('load', () => {
  new LazyLoad({
    rootMargin: '200px',
    root: null,
    threshold: 0,
    imageOptions: {
      classDefault: 'lazy-image',
      classOnLoad: 'lazy-image--active',
    },
    mode: LazyMode.EXCLUDE,
    url: '/api/image/',
    selectors: ['[data-item="svg"]', '[data-nolazy="true"]'],
  })
})

// Reinit lazy load on custom event

window.addEventListener('bw-lazy-reload', () => {
  new LazyLoad({
    rootMargin: '200px',
    root: null,
    threshold: 0,
    imageOptions: {
      classDefault: 'lazy-image',
      classOnLoad: 'lazy-image--active',
    },
    mode: LazyMode.EXCLUDE,
    url: '/api/image/',
    selectors: ['[data-item="svg"]', '[data-nolazy="true"]'],
  })
})

// COMPONENTS

import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';

// Init custom scrollbar
window.addEventListener('load', () => {
  initCustomScroll();
})

// Handle reinit on custom event
document.body.addEventListener('bw-custom-scroll-reload', () => {
  initCustomScroll();
})

function initCustomScroll() {
  // Find all elements where custom scroll should be initialized
  const scrollsContainers = document.querySelectorAll(`[data-custom-scroll='init']`);
  if (scrollsContainers.length > 0) {
    scrollsContainers.forEach(container => {
      // Check if custom srcoll has ben alread init on this container
      if (container.getAttribute("data-custom-scroll-active") != "true") {
        container.setAttribute("data-custom-scroll-active", "true");

        new SimpleBar(container, { autoHide: false });
      }
    })
  }
}

// Remove preload class on load
window.addEventListener('load', () => {
  // hide loader
  window.setTimeout(() => {
    const loader = document.querySelector("[data-item='loader']")
    const loaderStyle = document.querySelector("[data-item='loader-styles']")

    if (loader && loader.parentNode) {
      loader.parentNode.removeChild(loader)
    }
    if (loaderStyle && loaderStyle.parentNode) {
      loaderStyle.parentNode.removeChild(loaderStyle)
    }
  }, 250)

  // Remove class that prevent transition
  const preload = document.querySelector('body')
  if (preload) {
    preload.classList.remove('preload')
  }

  // Check browser
  const isSafariBrowser = () => navigator.userAgent.indexOf('Safari') > -1 && navigator.userAgent.indexOf('Chrome') <= -1

  if (isSafariBrowser()) {
    const body = document.querySelector('body');

    if (body) {
      body.classList.add('is-safari-browser')
    }
  }

})
